// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./slices/themeSlice";
import menuTogglerReducer from "./slices/menuTogglerSlice";
import sidebarReducer from "./slices/sidebarSlice";
import layoutReducer from "./slices/layoutSlice";
import bookAppointmentReducer from "./slices/bookAppointmentSlice";
import fundWalletReducer from "./slices/fundWalletSlice";
import walletTransferReducer from "./slices/walletTransferSlice";
import walletWithdrawReducer from "./slices/walletWithdrawSlice";
import walletSettingsReducer from "./slices/walletSettingsSlice";
// import { localStorageMiddleware } from "utils/localstore";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    menuToggler: menuTogglerReducer,
    sidebar: sidebarReducer,
    layout: layoutReducer,
    bookAppointment: bookAppointmentReducer,
    fundWallet: fundWalletReducer,
    walletTransfer: walletTransferReducer,
    walletWithdraw: walletWithdrawReducer,
    walletSettings: walletSettingsReducer
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware().concat(localStorageMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
